import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import ProcesoAdmision from '@/pages/ProcesoAdmision';
import NuestraEscuela from '@/pages/NuestraEscuela';
import Informaciones from '@/pages/Informaciones';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-white w-full relative">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/proceso-admision" element={<ProcesoAdmision />} />
          <Route path="/informaciones" element={<Informaciones />} />
          <Route path="/nuestra-escuela" element={<NuestraEscuela />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
